<mat-form-field class="full-width">
  <mat-label *ngIf="label != ''">{{label}}</mat-label>
  <textarea [formControl]="formCtrl | formControl" matInput [cdkTextareaAutosize]="true" [placeholder]="placeHolder"
    title="{{placeHolder}}" [matTooltip]="toolTip" [readonly]="readOnlyInd"
    rows="{{rows}}"></textarea>
  <button type="button" *ngIf="formCtrl.value!=='' && readOnlyInd===false" matSuffix aria-label="Clear"
    [hidden]="disableClearBtn"
    (click)="clearControl()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="formCtrl.errors">{{errormessage}}</mat-error>
</mat-form-field>